<section class="footer pb-5 mt-auto">
    <footer class="footer-header footer-anchor text-white">
        <div class="container">
            <div class="row">
                <div class="col-lg-3 mb-3 footer-links">
                    <!-- brand logo -->
                    <a href="#">
                        <img class="footer-logo" src="../../../../assets/img/illusbook_by_goodsketches.svg" alt="illusbook">
                    </a>
                    <div class="copyright mb-3">
                        © 2026 Illusbook. All Rights Reserved.
                    </div>
                    <!-- <div class="social-links pt-3 pt-md-0">
                         <a target="blank" href="https://www.linkedin.com/company/illusbook/" class="linkedin"><i
                                class="fab fa-linkedin"></i>&nbsp; <small>Linkedin</small></a>
                        <a target="blank" href="https://www.instagram.com/illusbook/" class="instagram"><i
                                class="fab fa-instagram"></i>&nbsp; <small>Instagram</small></a>
             </div> -->
                </div>

                <div class="col-6 col-lg-2 offset-lg-1 footer-links">
                    <h2 class="fw-semi fs-6 text-uppercase text-muted">Categories</h2>
                    <ul class="list-unstyled text-small">
                        <li><a class="text-footer text-white"
                                href="https://illusbook.com/search?cate=Festival">Festival</a></li>
                        <li><a class="text-footer text-white"
                                href="https://illusbook.com/search?cate=Education">Education</a></li>
                        <li><a class="text-footer text-white"
                                href="https://illusbook.com/search?cate=Technology">Technology</a></li>
                        <li><a class="text-footer text-white"
                                href="https://illusbook.com/search?cate=Business">Business</a></li>
                        <li><a class="text-footer text-white"
                                href="https://illusbook.com/search?cate=People">People</a></li>
                    </ul>
                </div>

                <div class="col-6 col-lg-2 mb-3 footer-links">
                    <div class="row">
                        <h2 class="fw-semi fs-6 text-uppercase text-muted">Information</h2>
                        <ul class="list-unstyled text-small">
                            <li *ngIf="!user || !user.isSubscribed"><a class="text-footer text-white" routerLink="/pricing">Pricing</a></li>
                            <li><a class="text-footer text-white" routerLink="/support">Support</a></li>
                            <li><a class="text-footer text-white" routerLink="/contact">Contact Us</a></li>
                        </ul>
                    </div>
                </div>

                 <div class="col-6 col-lg-2 mb-3 footer-links">
                    <div class="row">
                        <h2 class="fw-semi fs-6 text-uppercase text-muted">Information</h2>
                        <ul class="list-unstyled text-small">
                            <li><a class="text-footer text-white" routerLink="/terms">Terms & Conditions</a></li>
                            <li><a class="text-footer text-white" routerLink="/privacy">Privacy Policy</a></li>
                            <li><a class="text-footer text-white" routerLink="/shipping">Shipping Policy</a></li>
                            <li><a class="text-footer text-white" routerLink="/refund">Cancellation & Refund Policy</a></li>
                        </ul>
                    </div>
                </div>

                <div class="col-6 col-lg-2 mb-3 footer-links">
                    <h2 class="fw-semi fs-6 text-uppercase text-muted">Get in touch</h2>

                    <ul class="list-unstyled text-small">
                        <li>
                             <a target="_blank" href="https://www.linkedin.com/company/illusbook/" class="linkedin text-white"><i
                                class="fab fa-linkedin"></i>&nbsp; Linkedin</a>
                        </li>
                        
                        <li>
                            <a target="_blank" href="https://www.instagram.com/illusbook/" class="text-white"><i
                                class="fab fa-instagram"></i>&nbsp; Instagram</a>
                       </li>
                        <li>
                            <a target="_blank" href="https://x.com/illusbook" class="text-white">
                              <i class="fab fa-x"></i>&nbsp; Twitter</a>
                       </li>
                       <li>
                            <a target="_blank" href="https://pinterest.com/illusbook/" class="text-white"><i
                                class="fab fa-pinterest"></i>&nbsp; Pinterest</a>
                       </li>
                    </ul>
            
                </div>

            </div>
        </div>
    </footer>

</section>